import React, {useEffect, useRef} from "react";
import {default as MuiTooltip} from "@mui/material/Tooltip";

const Tooltip = props => {
    const {arrow = true, disable = false, titleCase = false, children, dangerousInnerHTML, ...other} = props;
    const tooltipRef = useRef(null);

    if (disable) {
        return children;
    }

    if (dangerousInnerHTML) {
        return (
            <MuiTooltip
                ref={tooltipRef}
                classes={{
                    tooltip: "ch-tooltip" + titleCase ? " ch-title-case-text" : ""
                }}
                arrow={arrow}
                {...other}
            >
                <div dangerouslySetInnerHTML={{__html: dangerousInnerHTML}}></div>
            </MuiTooltip>
        )
    }

    return (
        <MuiTooltip
            ref={tooltipRef}
            classes={{
                tooltip: "ch-tooltip"
            }}
            arrow={arrow}
            {...other}
        >
            {children}
        </MuiTooltip>
    )
}

export default Tooltip;